/* @flow */
import React from 'react';
import { markAccountCreationStart } from 'utils/accountCompletionTracker';

class JoinView extends React.Component {
  componentDidMount() {
    markAccountCreationStart();
  }

  render() {
    return this.props.children;
  }
}

export default JoinView;



// WEBPACK FOOTER //
// ./src/join/components/JoinView.jsx